import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Nav from './components/Nav';
import HomePage from './features/home/HomePage';
import AboutPage from './features/about/AboutPage';
import ContactPage from './features/contact/ContactPage';
import PrivacyPage from './features/privacy/PrivacyPage';
import TermsPage from './features/terms/TermsPage';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Nav />
        <div className="page-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
